const getMaxSelectedStops = (oldSelection, newSelection, meta) => {
  let numOfStops
  const selectedStops = Object.assign({}, oldSelection, newSelection)

  // checking if true for each key to determine the highest numStops we should display
  if (selectedStops['0']) {
    numOfStops = '0'
  }

  if (selectedStops['1']) {
    numOfStops = '1'
  }

  if (selectedStops['7']) {
    numOfStops = '7'
  }

  if (meta && meta.isOnlyClick) {
    numOfStops = Object.keys(newSelection)[0]
  }

  return numOfStops
}

export { getMaxSelectedStops }
